/**
 * Navigation helpers to handle React Navigation imports robustly
 * Fixes intermittent issues with createStackNavigator not being a function in release builds
 */
import * as NavigationStack from '@react-navigation/stack';

// Defensive import to handle Hermes/Metro bundling issues in release builds
export const createStackNavigator = (() => {
  const stackNavigator =
    NavigationStack.createStackNavigator ||
    (NavigationStack as any).default?.createStackNavigator ||
    (NavigationStack as any)?.createStackNavigator;

  if (!stackNavigator) {
    console.error(
      'createStackNavigator is not available. Navigation Stack module:',
      NavigationStack
    );
    throw new Error(
      'createStackNavigator is not available. Please check @react-navigation/stack installation.'
    );
  }

  return stackNavigator;
})();

// Re-export other commonly used types and functions from the stack navigator
export type {
  StackNavigationOptions,
  StackHeaderProps,
  StackNavigationProp,
} from '@react-navigation/stack';
